export const administration = {
    route: '管理',
    allHomesLabel: '所有场所',
    allUsersLabel: '所有用户',
    sureToDeleteUserContent: '删除的用户: ',
    sureToUndeleteUserContent: '取消删除的用户: ',
    invitationPending: '待定邀请'
};
